<div class="menu-item menu-lg-down-accordion me-lg-1 menu-dropdown" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start">
  <span class="menu-link py-3" [ngClass]="calculateMenuItemCssClass(menu.url!)">
    <span class="menu-title header-menu-title">{{
      menu.title | translate
      }}</span>
    <span class="menu-arrow d-lg-none"></span>
  </span>

  <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" data-kt-menu-dismiss="true" data-popper-placement="bottom-start">
    <div *ngFor="let sub_menu of menu.children" class="menu-item me-lg-1 menu-lg-down-accordion" data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start">
      @if ( sub_menu.type === 'accordion') {
      <span class="menu-link py-3" [ngClass]="calculateMenuItemCssClass(menu.url!)">
        @if (sub_menu.icon!.length) {
        <span class="menu-icon">
          <app-keenicon [name]="sub_menu.icon!" class="fs-2 svg-icon svg-icon-2"></app-keenicon>
        </span>
        }@else {
        <span class="menu-bullet">
          <span class="bullet bullet-dot"></span>
        </span>
        }
        <span class="menu-title">{{ sub_menu.title | translate }}</span>

        <span class="menu-arrow"></span>
      </span>
      <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" data-kt-menu-dismiss="true">
        <ng-container *ngFor="let children of sub_menu.children">
          @if (children.type=== 'accordion') {
          <div class="menu-item menu-lg-down-accordion me-lg-1" data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement="right-start">
            <span class="menu-link py-3" [ngClass]="calculateMenuItemCssClass(children.url!)">
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title" [attr.data-link]="children.url">{{ children.title | translate }}
              </span>
              <span class="menu-arrow"></span>
            </span>

            <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" data-kt-menu-dismiss="true">
              <div *ngFor="let sub_children of children.children" class="menu-item me-lg-1">
                <a class="menu-link py-3" routerLinkActive="active" [routerLink]="sub_children.url">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    sub_children.title | translate
                    }}</span>
                </a>
              </div>
            </div>
          </div>
          } @else {
          <div class="menu-item me-lg-1">
            <a class="menu-link py-3" routerLinkActive="active menu-here" [routerLink]="sub_menu.url">
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">{{ sub_menu.title | translate }}</span>
            </a>
          </div>
          }
        </ng-container>
      </div>
      } @else {
      <a class="menu-link py-3" routerLinkActive="active" [routerLink]="sub_menu.url">
        @if (sub_menu.icon!.length) {
        <span class="menu-icon">
          <app-keenicon [name]="sub_menu.icon!" class="fs-2 svg-icon svg-icon-2"></app-keenicon>
        </span>
        }@else {
        <span class="menu-bullet">
          <span class="bullet bullet-dot"></span>
        </span>
        }
        <span class="menu-title">{{ sub_menu.title | translate }}</span>
      </a>
      } @if ( sub_menu.type === 'accordion') { }
    </div>
  </div>
</div>